+function ($) {
    'use strict';

    var MenuClipper = function (element, option) {
        this.$element = $(element);
        this.$target = $(this.$element.data('target'));
        this.status = false;
        this.animate = false;

        this.windowWidth = $(window).width();

        var self = this;

        this.$element.bind('click', function () {
            self.toggle();
        });
    };

    MenuClipper.prototype.toggle = function () {
        if (this.status) {
            this.hide();
        } else {
            this.show();
        }
    };

    MenuClipper.prototype.show = function () {
        if (!this.status && !this.animate) {
            this.animate = true;
            var self = this;
            this.$element.addClass('header__menu__toggle_active');
            this.$target.show(500, 'swing', function () {
                self.status = true;
                self.animate = false;
                $('body').css('overflow', 'hidden');
            });
        }

    };

    MenuClipper.prototype.hide = function () {
        if (this.status && !this.animate) {
            this.animate = true;
            var self = this;
            this.$element.removeClass('header__menu__toggle_active');
            this.$target.hide(500, 'swing', function () {
                self.status = false;
                self.animate = false;
                $('body').css('overflow', 'auto');
            });
        }
    };

    var constructor = function (options) {
        //вернуть надо объект jQuery
        return this.each(function () {
            new MenuClipper(this, options);
        });
    };


    var old = $.fn.menuClipper;

    $.fn.menuClipper = constructor;
    $.fn.menuClipper.constructor = constructor;

    $.fn.menuClipper.noConflict = function () {
        $.fn.menuClipper = old;
        return this;
    }
}(jQuery);